var map = {
	"./Messages.jpg": 29933,
	"./Messages.png": 14110,
	"./book.png": 6474,
	"./box.png": 19001,
	"./chat.png": 13758,
	"./chat_01.png": 61677,
	"./chat_02.png": 76781,
	"./chat_icon.png": 4574,
	"./cloud.png": 54993,
	"./dashboard.png": 9779,
	"./dot.png": 36097,
	"./get_started_bg.png": 85837,
	"./john.png": 71096,
	"./left_leaf.png": 58183,
	"./live_chat.png": 601,
	"./mobile.png": 78039,
	"./panguin_img_one.png": 10129,
	"./panguin_img_three.png": 19043,
	"./panguin_img_two.png": 37580,
	"./pluse.png": 96771,
	"./richard.png": 78935,
	"./right_leaf.png": 38693,
	"./skyp_1.png": 37181,
	"./skyp_2.png": 9105,
	"./support_dashboard.jpg": 49085,
	"./triangle.png": 26278,
	"./video_icon.png": 22025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69903;